/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Copy_Magic_LinkInputs */

const en_copy_magic_link = /** @type {(inputs: Copy_Magic_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copy magic link`)
};

const es_copy_magic_link = /** @type {(inputs: Copy_Magic_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copiar link magico`)
};

/**
* | output |
* | --- |
* | "Copy magic link" |
*
* @param {Copy_Magic_LinkInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const copy_magic_link = /** @type {((inputs?: Copy_Magic_LinkInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Copy_Magic_LinkInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_copy_magic_link(inputs)
	return es_copy_magic_link(inputs)
});